import type { Uuid } from '@sibe/utilities/common';
import { HsObjectQueue } from '../../engine-new/filtering/object-queue.class';
import type { HsGraphicObject } from './graphic-object.class';
import type { HsGraphics } from '../graphics.class';

/**
 * Handles s graphic queue.
 */
export class HsGraphicQueue extends HsObjectQueue {
  public readonly objects: Map<Uuid, HsGraphicObject> = new Map<Uuid, HsGraphicObject>();

  public addObject(object: HsGraphicObject): HsGraphicQueue {
    this.objects.set(object.uuid, object);
    return this;
  }

  public addObjects(objects: HsGraphicObject[]): HsGraphicQueue {
    for (let i: number = 0; i < objects.length; i++) {
      this.objects.set(objects[i].uuid, objects[i]);
    }
    return this;
  }

  public removeObject(object: HsGraphicObject): boolean {
    return this.objects.delete(object.uuid);
  }

  public getObjectsCount(): number {
    return this.objects.size;
  }

  public clear(graphics: HsGraphics): void {
    const objectValues: IterableIterator<HsGraphicObject> = this.objects.values();
    for (let i: number = 0; i < this.objects.size; i++) {
      const element: IteratorResult<HsGraphicObject> = objectValues.next();
      const object: HsGraphicObject = element.value;
      object.isDeleted = true;
      graphics.deleteBuffer(object.geometry.buffer);
      object.geometry.isDeleted = true;
    }
    this.objects.clear();
  }
}
